module.exports = __webpack_public_path__ + "static/media/logo_min.35b81f9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench2/UI.Header/logo_min.png
// module id = 7093
// module chunks = 0